import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { BrowserModule } from "@angular/platform-browser";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { AccordionModule } from "primeng/accordion";

import { AppSharedModule } from "../../shared/app-shared.module";
import { AdminRoutes } from "./admin-routes";
import { AdminComponent } from "./index";

import { PersonSelectorModule } from "../personselector/personselector.module";

// Guardian Notification Registration
import { GuardianNotificationRegComponent } from "./guardiannotificationregistration/guardiannotificationreg.component";
import { GuardianNotificationRegService } from "./guardiannotificationregistration/guardiannotificationreg.service";

// Barcode Management
import { BarcodeComponent } from "./barcode/barcode.component";
import { StatusComponent } from "./barcode/status/status.component";
import { StatusMTAComponent } from "./barcode/statusmta/statusmta.component";
import { DataService_barcode } from "./barcode/shared/data.service";

// Triggers
import { TriggersComponent } from "./triggers/triggers.component";

// Meal Assignments
import { MealAssignmentComponent } from "./mealassignment/mealassignment.component";
import { DataService_mealassignment } from "./mealassignment/shared/data.service";

// Application Maintenance
import { ApplicationSetupComponent } from "./application-setup/application-setup.component";
import { ApplicationTableComponent } from "./application-setup/application-table/application-table.component";
import { SchoolTableComponent } from "./application-setup/school-table/school-table.component";
import { DataService_AppSetup } from "./application-setup/shared/data.service";
import { ApplicationItemTableComponent } from "./application-setup/application-item-table/application-item-table.component";
import { ApplicationAddSchoolComponent } from "./application-setup/school-table/application-add-school/application-add-school.component";

import { SubstitutionMaintenanceComponent } from "./substitution-maintenance/substitution-maintenance.component";
import { AddSubstitutePersonComponent } from "./substitution-maintenance/sub-main-table/add-substitute-person/add-substitute-person.component";
import { AddSubstitutionSwapComponent } from "./substitution-maintenance/sub-main-table/add-substitution-swap/add-substitution-swap.component";
import { SubMainTableComponent } from "./substitution-maintenance/sub-main-table/sub-main-table.component";
import { SubHistoryTableComponent } from "./substitution-maintenance/sub-history-table/sub-history-table.component";
import { DataService_SubstituteMaintenance } from "./substitution-maintenance/shared/data.service";
import { ModifySubstitutionComponent } from "./substitution-maintenance/sub-main-table/add-substitution-swap/modify-substitution/modify-substitution.component";
import { SubHistoryDetailsComponent } from "./substitution-maintenance/sub-history-table/sub-history-details/sub-history-details.component";

import { ViewApplicationLogsComponent } from "./view-application-logs/view-application-logs.component";
import { SchoolAdminService } from "./services/schooladmin.service";
import { LogDetailComponent } from "./view-application-logs/log-detail/log-detail.component";

//Batch Attendance

import { BatchAttendanceComponent } from "./batchattendance/batchattendance.component";
import { DataService_batchattendance } from "./batchattendance/shared/data.service";
import { AddTriggerComponent } from "./triggers/add-trigger/add-trigger.component";
import { ViewTriggerComponent } from "./triggers/view-trigger/view-trigger.component";
import * as moment from "moment";

import { ZeroOutAccountsComponent } from "./zero-out-accounts/zero-out-accounts.component";
import { AccountSummaryReportComponent } from "./zero-out-accounts/account-summary-report/account-summary-report.component";

//New School Incident
import { SchoolIncidentSetupComponent } from "./school-incident-setup/school-incident-setup.component";
import { AddSchoolIncidentComponent } from "./school-incident-setup/add-school-incident/add-school-incident.component";
import { EditSchoolIncidentComponent } from "./school-incident-setup/edit-school-incident/edit-school-incident.component";
import { DataService_SchoolIncidentSetup } from "./school-incident-setup/shared/data.service";
import { GuardianNotificationBatchComponent } from "./guardian-notification-batch/guardian-notification-batch.component";
import { GuardianNotifyBatchImportComponent } from "./guardian-notification-batch/guardian-notify-batch-import/guardian-notify-batch-import.component";
import { GuardianNotifyBatchExportComponent } from "./guardian-notification-batch/guardian-notify-batch-export/guardian-notify-batch-export.component";
import { DataService_NotifyRegBatch } from "./guardian-notification-batch/shared/data.service";
import { GuardianNotifyImportPreviewComponent } from "./guardian-notification-batch/guardian-notify-import-preview/guardian-notify-import-preview.component";
import { GuardianNotifyEmailLogComponent } from "./guardian-notification-batch/guardian-notify-email-log/guardian-notify-email-log.component";
import { GuardianNotifyDownloadComponent } from "./guardian-notification-batch/guardian-notify-download/guardian-notify-download.component";
import { BatchAttendanceCsvComponent } from './batchattendance/batch-attendance-csv/batch-attendance-csv.component';
import { BatchAttendanceCsvUploadComponent } from './batchattendance/batch-attendance-csv/batch-attendance-csv-upload/batch-attendance-csv-upload.component';
import { BatchAttendanceCsvPreviewTableComponent } from './batchattendance/batch-attendance-csv/batch-attendance-csv-preview-table/batch-attendance-csv-preview-table.component';

@NgModule({
	declarations: [
		AdminComponent,
		GuardianNotificationRegComponent,
		BarcodeComponent,
		StatusComponent,
		StatusMTAComponent,
		TriggersComponent,
		MealAssignmentComponent,
		ViewApplicationLogsComponent,
		LogDetailComponent,
		BatchAttendanceComponent,
		AddTriggerComponent,
		ViewTriggerComponent,
		ZeroOutAccountsComponent,
		AccountSummaryReportComponent,
		SchoolIncidentSetupComponent,
		AddSchoolIncidentComponent,
		EditSchoolIncidentComponent,
		GuardianNotificationBatchComponent,
		GuardianNotifyBatchImportComponent,
		GuardianNotifyBatchExportComponent,
		GuardianNotifyImportPreviewComponent,
		GuardianNotifyEmailLogComponent,
		GuardianNotifyDownloadComponent,
		ApplicationSetupComponent,
		ApplicationTableComponent,
		SchoolTableComponent,
		ApplicationItemTableComponent,
		ApplicationAddSchoolComponent,
		SubstitutionMaintenanceComponent,
		AddSubstitutePersonComponent,
		AddSubstitutionSwapComponent,
		SubMainTableComponent,
		SubHistoryTableComponent,
		ModifySubstitutionComponent,
		SubHistoryDetailsComponent,
  BatchAttendanceCsvComponent,
  BatchAttendanceCsvUploadComponent,
  BatchAttendanceCsvPreviewTableComponent,
	],
	imports: [
		BrowserModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		InputTextareaModule,
		CalendarModule,
		AccordionModule,
		SchoolselectorModule,
	],
	providers: [
		DatePipe,
		ConfirmationService,
		GuardianNotificationRegService,
		DataService_barcode,
		DataService_batchattendance,
		DataService_mealassignment,
		SchoolAdminService,
		DataService_SchoolIncidentSetup,
		DataService_NotifyRegBatch,
		DataService_AppSetup,
		DataService_SubstituteMaintenance,
	],
})
export class AdminModule {}
